import { useAuth } from '@/auth/AuthContext'
import AlterarSenhaModal from '@/components/AlterarSenhaModal'
import { Dropdown, DropdownItem } from '@/components/ui/dropdown'
import { cn } from '@/lib/utils'
import { ChevronDown, KeyRound, LogOut } from 'lucide-react'
import { useState } from 'react'
import { FcApproval, FcDocument, FcSettings } from "react-icons/fc"
import { NavLink, Outlet } from 'react-router-dom'

const nav = [
  { to: '/contrato', label: 'Contratos', icon: FcDocument },
  { to: '/nf', label: 'Notas Fiscais', icon: FcApproval },
  { to: '/cadastro', label: 'Cadastros', icon: FcSettings  },
]

export default function Layout() {
  const { user, logout } = useAuth()
  const [senhaOpen, setSenhaOpen] = useState(false)

  return (
    <div className="h-screen flex flex-col bg-background text-foreground">
      <header className="h-16 shrink-0 border-b border-border bg-card grid grid-cols-3 items-center px-6">
        {/* Esquerda: logomarca */}
        <div className="flex items-center">
          <span className="font-bold text-xl tracking-tight text-primary">
            <img src="/precisa.png" alt="Logo" className="h-5 w-auto" />
          </span>
        </div>

        {/* Centro: menu */}
        <nav className="flex items-center justify-center gap-1">
          {nav.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2 px-4 py-2 rounded-md text-sm font-semibold transition-colors',
                  isActive
                    ? 'bg-accent text-accent-foreground'
                    : 'text-muted-foreground hover:bg-accent/60 hover:text-foreground'
                )
              }
            >
              <Icon className="h-5.5 w-5.5" />
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Direita: usuário logado (dropdown com alterar senha / sair) */}
        <div className="flex items-center justify-end">
          <Dropdown
            trigger={
              <button className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-muted-foreground hover:bg-accent/60 hover:text-foreground transition-colors">
                <span className="truncate max-w-[180px]">{user?.nome}</span>
                <ChevronDown className="h-4 w-4 shrink-0" />
              </button>
            }
          >
            <DropdownItem onClick={() => setSenhaOpen(true)}>
              <KeyRound className="h-4 w-4 text-muted-foreground" /> Alterar senha
            </DropdownItem>
            <DropdownItem onClick={logout}>
              <LogOut className="h-4 w-4 text-muted-foreground" /> Sair
            </DropdownItem>
          </Dropdown>
        </div>
      </header>

      <main className="flex-1 min-h-0 overflow-auto">
        <Outlet />
      </main>

      <AlterarSenhaModal open={senhaOpen} onClose={() => setSenhaOpen(false)} />
    </div>
  )
}
